import { Segment } from 'fitify-ui-onboarding/src/components/Paywall/Segment/Segment'
import { SegmentCard } from 'fitify-ui-onboarding/src/components/Paywall/Segment/Segment.Styled'
import { useTranslation } from 'next-i18next/pages'
import { styled, useTheme } from 'styled-components'

import { getImageProps } from 'utils/images'

const StyledImagesWrapper = styled(SegmentCard)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 12px;
`

export const FeaturedIn = () => {
  const { t } = useTranslation()
  const { isDarkTheme } = useTheme()

  return (
    <Segment title={t('paywall_as_featured_in')}>
      <StyledImagesWrapper>
        <img
          alt="Featured in logos"
          {...getImageProps(
            'shared',
            'subscription',
            isDarkTheme ? 'featuredInWhite' : 'featuredInDark'
          )}
        />
      </StyledImagesWrapper>
    </Segment>
  )
}
